// historieStorage.ts — remembers the last fund chosen on the Historie page
// (views/HistorieView.tsx), the same guarded localStorage pattern as storage.ts/
// settings.ts (no-DOM / private-browsing / storage-full all degrade to a no-op rather
// than throwing — nothing tax-critical lives only here, it's a UX convenience).
const STORAGE_KEY = 'etf-cockpit:historie:lastIsin';

export function loadLastHistorieIsin(): string | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function saveLastHistorieIsin(isin: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, isin);
  } catch {
    // Storage full/disabled — silently drop.
  }
}
